export default "__VITE_ASSET__Ht_TeX$E__"